import { Directive, ElementRef, HostListener } from '@angular/core';
import ResizeObserver from 'resize-observer-polyfill';

@Directive({
  selector: '[xsightAutoSizeFrame]',
})
export class AutoSizeFrameDirective {
  constructor(private el: ElementRef) {}

  iFrame: HTMLIFrameElement;
  observer: ResizeObserver;

  ngOnInit() {
    this.iFrame = this.el.nativeElement;
    this.observer = new ResizeObserver(() => {
      this.resizeIframe();
    });
    this.observer.observe(this.iFrame);
  }
  @HostListener('load')
  onFrameContentLoaded() {
    this.resizeIframe();
  }

  resizeIframe() {
    if (this.iFrame) {
      this.iFrame.height = this.iFrame.contentWindow?.document.body?.scrollHeight + 20 + 'px';
    }
  }

  OnDestroy() {
    this.observer.disconnect();
  }
}
